
(function () {
  'use strict';

  const SHOPIFY_CDN = /cdn\.shopify\.com|cdn\/shop\/files|adrianadegreas\.com\.br\/cdn/;
  const HOVER_ATTRS = ['data-sih-src', 'data-hover-src', 'data-secondary-image', 'data-flip-image'];
  const MAX_DPR = 2;

  function buildExactUrl(originalUrl, displayWidth) {
    if (!originalUrl || !SHOPIFY_CDN.test(originalUrl)) return originalUrl;
    const dpr = Math.min(window.devicePixelRatio || 1, MAX_DPR);
    const exactWidth = Math.max(200, Math.ceil(displayWidth * dpr));
    let url = originalUrl
      .replace(/[?&]width=\d+/g, '')
      .replace(/[?&]format=\w+/g, '');
    const sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=' + exactWidth + '&format=pjpg';
  }

  function getCardDisplayWidth(cardEl) {
    // Walk up to find the actual rendered card slot
    let el = cardEl;
    while (el && el !== document.body) {
      const rect = el.getBoundingClientRect();
      if (rect.width >= 100 && rect.width <= 800) {
        return rect.width;
      }
      el = el.parentElement;
    }
    return 400; // sensible fallback for a typical 4-col grid card
  }

  function processCard(card) {
    if (card.dataset.hoverSizingApplied) return;

    // Find the card's main img to measure displayed width
    const mainImg = card.querySelector('img');
    const displayWidth = mainImg
      ? mainImg.getBoundingClientRect().width || getCardDisplayWidth(card)
      : getCardDisplayWidth(card);

    if (displayWidth < 100) return; // not laid out yet, try again later

    // Rewrite every hover-related attribute on every descendant
    HOVER_ATTRS.forEach((attr) => {
      card.querySelectorAll('[' + attr + ']').forEach((el) => {
        const original = el.getAttribute(attr);
        const rewritten = buildExactUrl(original, displayWidth);
        if (rewritten && rewritten !== original) {
          el.setAttribute(attr, rewritten);
        }
      });
    });

    card.dataset.hoverSizingApplied = 'true';
  }

  function processAll() {
    // Process every product card on the page (whatever your card selector is)
    document
      .querySelectorAll('product-card, .product-card, .card-product, [class*="product-card"]')
      .forEach(processCard);
  }

  function init() {
    // Wait for cards to fully render
    if (document.readyState === 'complete') {
      setTimeout(processAll, 200);
    } else {
      window.addEventListener('load', () => setTimeout(processAll, 200));
    }

    // Re-run on AJAX (collection filters, infinite scroll, theme editor)
    document.addEventListener('shopify:section:load', () => setTimeout(processAll, 100));

    // Watch for new cards added dynamically (filters, pagination)
    if (typeof MutationObserver !== 'undefined') {
      let timer;
      new MutationObserver(() => {
        clearTimeout(timer);
        timer = setTimeout(processAll, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }

    // Re-run on resize (changing layout may change card sizes)
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document.querySelectorAll('[data-hover-sizing-applied]').forEach((c) => {
          delete c.dataset.hoverSizingApplied;
        });
        processAll();
      }, 300);
    });
  }

  init();
})();